const perguntasTipoRespostaEnum = {
  texto: 1,
  numero: 2,
  boolean: 3,
};

export default perguntasTipoRespostaEnum;
